import * as React from "react";
import {Component} from "react";
import {Field, Form, getFormValues, reduxForm} from "redux-form";
import styles from "../../../styles/forms/superadmin/add_translation_wizard/AddTranslationForm.scss";
import Button from "../../../components/Button";
import Input from "../../../components/Input";
import {__, mapStateToProps, setTableParams} from "../../../core/utils";
import {withRouter} from "react-router";
import autobind from "autobind-decorator";
import ButtonGroup from "../../../components/ButtonGroup";
import {subscribe} from "react-contextual";
import Localization from "../../../helpers/Localization";
import Textarea from "../../../components/Textarea";

@withRouter
@reduxForm({form: "superadmin.add_translation_wizard.add_translation"})
@mapStateToProps(state => ({
    values: getFormValues("superadmin.add_translation_wizard.add_translation")(state),
    auth: state.auth,
}))
@subscribe(Localization, "localization")
class AddTranslationForm extends Component {
    @autobind
    _handleSubmit(edit) {
        this.props.change('edit', edit);

        setTimeout(() => this.props.submit(), 10);
    }

    render() {
        const languages = _.transform(_.filter(this.props.localization.languages, ['application_language', 1]), (languages, language) => {
            languages[language.id] = language.id == 1;
        }, {});

        return (
            <Form onSubmit={this.props.handleSubmit} className={styles.wrapper}>
                <div className={styles.form}>
                    <Field name="keyword" component={Input} label={__('superadmin.translations.add-translation.keyword')} />
                    <Field name="tag" component={Input} label={__('superadmin.translations.add-translation.tag')} />
                    <Field name="translations" component={Textarea} localized={languages} label={__('superadmin.translations.add-translation.translations')} />
                </div>
                <div className={styles.footer}>
                    <Button lightGray medium left middleText={__('button.cancel')} onClick={() => setTableParams('superadmin_translations', {
                        add_translation_wizard: undefined
                    })} />
                    <ButtonGroup>
                        <Button lightBlue medium middleText={__('button.create')} spinning={this.props.submitting} onClick={() => this._handleSubmit(false)} />
                        <Button lightBlue medium middleText={__('button.create-edit')} spinning={this.props.submitting} onClick={() => this._handleSubmit(true)} />
                    </ButtonGroup>
                </div>
            </Form>
        );
    }
}

export default AddTranslationForm;
